var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nuxt'),_vm._v(" "),_c('Footer',{style:(_vm.footerStyle)}),_vm._v(" "),_c('ScrollToTop'),_vm._v(" "),_c('client-only',[_c('CookieBanner',{ref:"cookieBanner"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }